module.exports = __webpack_public_path__ + "static/media/security.337b9018.svg";